(function () {
  const colorMap = {
    'TNT': '#cc0000',
    'LUCKY BLOCK': '#f5c400',
    'STEVE': '#1a6fbf',
    'ENDERMAN': '#111111',
    'CREEPER': '#3aab3a',
    'CERDO': '#f48fb1'
  };

  function forceColors() {
    document.querySelectorAll('.variant-option__button-label').forEach(label => {
      const input = label.querySelector('input');
      if (!input) return;
      const color = colorMap[input.value];
      if (!color) return;
      label.style.setProperty('background-color', color, 'important');
      label.style.setProperty('color', '#ffffff', 'important');
      label.style.setProperty('border-color', color, 'important');

      // Cruz si está seleccionado
      if (input.checked) {
        label.style.setProperty('outline', '3px solid #ffffff', 'important');
        label.style.setProperty('box-shadow', 'inset 0 0 0 2px ' + color + ', 0 0 0 3px ' + color, 'important');
        label.setAttribute('data-selected', 'true');
      } else {
        label.style.removeProperty('outline');
        label.style.removeProperty('box-shadow');
        label.removeAttribute('data-selected');
      }
    });
  }

  const style = document.createElement('style');
  style.textContent = `
    .variant-option__button-label[data-selected="true"]::after {
      content: '✓';
      position: absolute;
      top: 2px;
      right: 5px;
      font-size: 12px;
      font-weight: bold;
      color: #ffffff;
      text-shadow: 0 0 3px rgba(0,0,0,0.5);
    }
    .variant-option__button-label {
      position: relative !important;
    }
  `;
  document.head.appendChild(style);

  const observer = new MutationObserver(() => forceColors());

  document.addEventListener('DOMContentLoaded', () => {
    forceColors();
    document.addEventListener('change', e => {
      if (e.target.closest('.variant-option__button-label')) {
        setTimeout(forceColors, 50);
        setTimeout(forceColors, 200);
      }
    });
    observer.observe(document.body, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['class', 'style']
    });
  });
})();
